export const DONATE_URL = 'https://rethinktw.cc/Gh23e';
export const COURSE_APPLY_URL = 'https://rethinktw.cc/0PDKE';

export default {
  DONATE_URL,
  COURSE_APPLY_URL,
};
